const awsconfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USERPOOL_ID,
      userPoolClientId: process.env.REACT_APP_CLIENT_ID,
      region: "us-east-1",
      loginWith: {
        oauth: {
          domain: process.env.REACT_APP_DOMAIN,
          scopes: ["openid", "email", "phone", "fwapi/fw_admin_access"],
          redirectSignIn: [process.env.REACT_APP_REDIRECT_URL],
          redirectSignOut: [process.env.REACT_APP_REDIRECT_URL],
          responseType: "code",
        },
      },
    },
  },
};

export default awsconfig;
